<template>
  <div id="app">
    <main-header></main-header>
    <router-view />
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainHeader from './views/MainHeader'
import MainFooter from './views/MainFooter'

export default {
  components: {
    'main-header': MainHeader,
    'main-footer': MainFooter
  }
  // name: "App"
}
</script>
